import React from "react";
import clsx from "clsx";
import { Box, Typography } from "@material-ui/core";
import { useDeviceTypes } from "halifax";

import styles from "./styles.module.scss";

interface ChfarFlightSummaryWrapperProps {
  isChfarExercise: boolean;
}
export const ChfarFlightSummaryWrapper: React.FC<
  React.PropsWithChildren<ChfarFlightSummaryWrapperProps>
> = ({ isChfarExercise, children }) => {
  const { matchesMobile } = useDeviceTypes();
  if (isChfarExercise) {
    return (
      <Box
        className={clsx(styles["chfar-flight-summary-root"], {
          mobile: matchesMobile,
        })}
      >
        <Box
          className={clsx(styles["chfar-flight-summary-copy-section"], {
            mobile: matchesMobile,
          })}
        >
          <Typography
            variant="h2"
            className={styles["chfar-flight-summary-title"]}
          >
            Confirm and book your new flight
          </Typography>
          <Typography
            variant="body2"
            className={styles["chfar-flight-summary-text"]}
          >
            You are one step away from booking your new flight. Review the
            details, confirm and enjoy your trip!
          </Typography>
        </Box>
        <Box>{children}</Box>
      </Box>
    );
  }

  return (
    <Box className={styles["non-chfar-flight-summary-root"]}>{children}</Box>
  );
};
